export const STACK_TYPE_NORMAL = "normal";
export const STACK_TYPE_100_PERCENT = "100%";
export const DATA_LABELS_ENABLED = true;